import React from "react";

export const FlutterIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="34"
    viewBox="0 0 28 34"
    fill="none"
  >
    <path
      d="M16.9332 0.5L0.5 16.9332L5.58639 22.0196L27.1061 0.5H16.9332Z"
      fill="black"
    />
    <path
      d="M16.8187 15.6545L8.0199 24.4534L13.1254 29.6351L18.2024 24.5581L27.1061 15.6545H16.8187Z"
      fill="black"
    />
    <path
      d="M13.1255 29.6351L16.9904 33.5001H27.1061L18.2024 24.5581L13.1255 29.6351Z"
      fill="black"
    />
    <path
      d="M7.96265 24.5103L13.0492 19.4238L18.2023 24.558L13.1254 29.635L7.96265 24.5103Z"
      fill="black"
    />
    <path
      d="M13.1255 29.6351L17.353 28.2323L17.7729 24.9875L13.1255 29.6351Z"
      fill="url(#paint0_linear_12751_8360)"
      fillOpacity="0.8"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12751_8360"
        x1="31.4908"
        y1="150.439"
        x2="365.855"
        y2="270.928"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
